import { SellerCatalogCounts } from '@/types/SellerCatalogCounts';

export type SellerCatalogCountsSlice = {
    byId: { [sellerId: number]: SellerCatalogCounts };
    loaded: { [sellerId: number]: number };
    loading: number[];
};

export const defaultSellerCatalogCountsSlice: SellerCatalogCountsSlice = {
    byId: {},
    loaded: {},
    loading: [],
};
